import { useQuery } from "@tanstack/react-query";
import { admin, queryKeys } from "../../api/salvagers";

const count = (n: number, one: string, many: string) => `${n.toLocaleString()} ${n === 1 ? one : many}`;

const when = (iso: string | null) =>
  iso ? (
    <time dateTime={iso}>{new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}</time>
  ) : (
    "—"
  );

/** Who has visited, by IP, from the kast-dev family's central visitor log. */
export default function Visitors() {
  const visitors = useQuery({ queryKey: queryKeys.visitors, queryFn: admin.visitors });
  const rows = visitors.data ?? [];
  const sessions = rows.reduce((total, visitor) => total + visitor.count, 0);
  return (
    <section>
      <div className="section-head">
        <h2>Visitors</h2>
        <button className="btn" onClick={() => visitors.refetch()} disabled={visitors.isFetching}>
          Refresh
        </button>
      </div>
      {visitors.error && <p className="notice error">Could not load visitors.</p>}
      {visitors.data && (
        <>
          <p className="muted">
            {count(rows.length, "address", "addresses")} · {count(sessions, "session", "sessions")} · a session ends
            after 5 minutes idle
          </p>
          {rows.length === 0 ? (
            <p className="muted">No visitors logged yet.</p>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>IP</th>
                    <th className="number">Sessions</th>
                    <th>First seen</th>
                    <th>Last seen</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((visitor) => (
                    <tr key={visitor.ip}>
                      <td className="mono">{visitor.ip}</td>
                      <td className="number">{visitor.count.toLocaleString()}</td>
                      <td>{when(visitor.first_seen)}</td>
                      <td>{when(visitor.last_seen)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </section>
  );
}
